import { useState } from 'react'
import { Button } from '@mui/material'
import { useNotify, useRecordContext, useRefresh } from 'react-admin'
import { sendLog } from '../../../Class/AuditLog'

// TODO -  move this
const sendManualReviewRequest = async (quoteRequest) => {
  const request = new Request(
    `${process.env.REACT_APP_API_PLATFORM_ENDPOINT}/customer-reviews/manual-request`,
    {
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      }),
      method: 'POST',
      body: JSON.stringify({ quoteRequest }),
    }
  )

  return await fetch(request)
    .then((response) => response.json())
    .then((jsonResponse) => {
      if (jsonResponse.error !== undefined) {
        throw Error(jsonResponse.error)
      }

      return jsonResponse
    })
}

const RequestCustomerReview = () => {
  const record = useRecordContext()
  const refresh = useRefresh()
  const notify = useNotify()
  const [isLoading, setIsLoading] = useState(false)
  const manualReviewRecentlySent =
    record.manualReviewLastSent &&
    new Date(record.manualReviewLastSent).getTime() >
      Date.now() - 24 * 60 * 60 * 1000 // 24h

  const handleClick = async () => {
    setIsLoading(true)

    try {
      const response = await sendManualReviewRequest(record.originId)

      if (!response.success) {
        notify(response.message || 'Failed to request customer review.', {
          type: 'error',
        })
        return
      }

      await sendLog(
        record.originId,
        'Requested customer review',
        'LOG_MANUAL_REVIEW_REQUEST'
      )

      notify('Requested customer review.', {
        type: 'success',
      })
    } catch (error) {
      notify(error.message || 'Failed to request customer review.', {
        type: 'error',
      })
    } finally {
      setIsLoading(false)
      refresh()
    }
  }

  return (
    <>
      <Button
        fullWidth
        onClick={handleClick}
        disabled={isLoading}
        variant="contained"
        color={manualReviewRecentlySent ? 'success' : 'warning'}
      >
        {manualReviewRecentlySent ? 'Review requested' : 'Request review'}
      </Button>
    </>
  )
}

export default RequestCustomerReview
